import { Link } from 'react-router-dom';
import { Button, Card, CardContent } from '../components/ui';

// Mock data for featured games
const featuredGames = [
  {
    id: 'snake',
    name: 'Snake',
    category: 'Arcade',
    players: '2.5k',
    image: '🐍',
  },
  {
    id: 'falling-blocks',
    name: 'Falling Blocks',
    category: 'Puzzle',
    players: '3.1k',
    image: '🧱',
  },
  {
    id: 'wall-breaker',
    name: 'Wall Breaker',
    category: 'Arcade',
    players: '1.8k',
    image: '🧱',
  },
  {
    id: 'pill-muncher',
    name: 'Pill Muncher',
    category: 'Arcade',
    players: '4.2k',
    image: '👻',
  },
];

const categories = [
  { id: 'arcade', name: 'Arcade', count: 12, icon: '🕹️' },
  { id: 'puzzle', name: 'Puzzle', count: 8, icon: '🧩' },
  { id: 'casual', name: 'Casual', count: 15, icon: '🎮' },
  { id: 'strategy', name: 'Strategy', count: 6, icon: '♟️' },
];

export function HomePage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-purple-900/20 to-transparent pointer-events-none" />

        <div className="container mx-auto relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Play Classic Games
              <br />
              <span className="text-purple-400">After 5PM</span>
            </h1>
            <p className="text-xl text-slate-300 mb-8">
              Relive the golden age of arcade gaming. Snake, Falling Blocks,
              Wall Breaker, and more — all playable in your browser. No
              downloads, no ads, just pure fun.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/games">
                <Button size="lg">Browse Games</Button>
              </Link>
              <Link to="/leaderboards">
                <Button variant="outline" size="lg">
                  View Leaderboards
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Games */}
      <section className="py-16 px-4">
        <div className="container mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-bold text-white">Featured Games</h2>
            <Link
              to="/games"
              className="text-purple-400 hover:text-purple-300 text-sm font-medium"
            >
              View all →
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredGames.map((game) => (
              <Link key={game.id} to={`/games/${game.id}`}>
                <Card
                  variant="interactive"
                  padding="none"
                  className="group overflow-hidden"
                >
                  {/* Game thumbnail placeholder */}
                  <div className="aspect-video bg-slate-700/50 flex items-center justify-center text-6xl">
                    {game.image}
                  </div>
                  <CardContent className="p-4">
                    <h3 className="text-lg font-semibold text-white group-hover:text-purple-400 transition-colors">
                      {game.name}
                    </h3>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-sm text-slate-400">
                        {game.category}
                      </span>
                      <span className="text-sm text-slate-500">
                        {game.players} playing
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-16 px-4 bg-slate-800/30">
        <div className="container mx-auto">
          <h2 className="text-2xl font-bold text-white mb-8">
            Browse by Category
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {categories.map((category) => (
              <Link key={category.id} to={`/games?category=${category.id}`}>
                <Card variant="interactive" className="text-center">
                  <div className="text-4xl mb-3">{category.icon}</div>
                  <h3 className="text-lg font-semibold text-white">
                    {category.name}
                  </h3>
                  <p className="text-sm text-slate-400 mt-1">
                    {category.count} games
                  </p>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <Card variant="elevated" className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-bold text-white mb-4">
              Ready to climb the leaderboards?
            </h2>
            <p className="text-slate-300 mb-6">
              Create a free account to save your high scores, compete with
              friends, and unlock achievements.
            </p>
            <Button size="lg">Create Free Account</Button>
          </Card>
        </div>
      </section>
    </div>
  );
}
